import React from "react";
import { Link } from "react-router-dom";
import { FaBars } from "react-icons/fa";
import { BsXLg } from "react-icons/bs";
import { appDomain, getLogoImagePath } from "../../Util/general-config";
import { ROUTE_CONSTANT } from "../../Util/Constants";
import { useNavigate } from "react-router-dom";

type Props = {
  children?: React.ReactNode;
  handleShow: React.MouseEventHandler;
  handleClose: React.MouseEventHandler;
  isOpen: boolean;
  tempClass?: string;
};

const TemplateHeader = ({ children, handleShow, handleClose, isOpen, tempClass }: Props) => {
  const navigate = useNavigate();
  const HomeNavigate = () => {
    if (process.env.NODE_ENV == "development") {
      navigate(ROUTE_CONSTANT.LANDINGPAGE);
    } else {
      window.location.href = appDomain();
    }
  };

  return (
    <div className={(!!tempClass ? "d-flex " + tempClass : "d-flex") + " border-bottom border-[#EAEBED] mb-3"}>
      <div onClick={HomeNavigate} className="displaymobile">
        <img
          className="legalsimpli-logo height-37 mt-3 mb-3 ps-20"
          src={getLogoImagePath()}
          alt="PDFsimpli"
          draggable="false"
        />
      </div>
      {/* <Link to="/" className="displaymobile">
        <img
          src={process.env.PUBLIC_URL + "/static/images/LEGALSimpli-logo.svg"}
          className="height-37 mt-3 mb-3 ps-20"
        />
      </Link> */}
      <div className="container displaylogo">
        <nav className="navbar pt-0 custom_nav">
          <Link to="/">
            <img src={getLogoImagePath()} className="height-26 mt-3 mb-3 me-40" />
          </Link>
        </nav>
      </div>{" "}
      <nav className="navbar navbar-expand-lg navbar-light mx-2 pointer">
        <div
          className="navbar-toggler border-0 ml-3"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          {isOpen ? <BsXLg size={24} onClick={handleClose} /> : <FaBars size={24} onClick={handleShow} />}
        </div>
      </nav>
      <div className="overlay" style={{ display: "none" }}></div>
    </div>
  );
};

export default TemplateHeader;
